import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import DocumentTitle from '../../components/DocumentTitle/DocumentTitle'
import { ToWords } from 'to-words';
import { DataGridPremium, GridToolbar,frFR } from "@mui/x-data-grid-premium";
import { formatStringNumber } from '../../services/Helpers/fonctions';
import Box from "@mui/material/Box";
import { 
  Menu, 
  MenuItem, 
  Button, 
  Typography 
} from '@mui/material';
import Erreurs from '../../components/Erreurs/Erreurs';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGridApiRef } from '@mui/x-data-grid';
import { useRecoilState } from 'recoil';
import { loadingState } from '../../recoil/atoms/loadingAtom';
import ToolbarVadis from '../../components/Vadis/ToolBarPaiementListVadis/ToolBarPaiementListVadis';
import Api from '../../services/Api';
import moment from 'moment/moment';
import PayVirement from '../../components/PayVirement/PayVirement';
import { UserContext } from '../../services/Context/Context';
import Paymentgrp from '../../components/Vadis/Paymentgrp/Paymentgrp';
function PaymentListVadis() {
    const toWords = new ToWords({
        localeCode: 'fr-FR',
        converterOptions: {
          currency: false,
          ignoreDecimal: false,
          ignoreZeroCurrency: false,
          doNotAddOnly: false,
        }
      });
  const[ pageState,setPageState ] = useState({
      data:[],
      total: 0,
      page: 1,
      pageSize: 10 
  });
  const[ totalPayer,setTotalPayer ] = useState(0);
  const[ totalNonPayer,setTotalNonPayer ] = useState(0); 
  const[erreurs,setErreurs ] = useState([]);
  const navigate = useNavigate();
  const api = new Api();
  const [filterData, setFilterData] = useState({ items: [] });
  const [filterModel, setFilterModel] = useState({ items: [] });
  const[ isLoading,setIsLoading ] = useRecoilState(loadingState);
  const[ modalOpen,setModalOpen ] = useState(false);
  const[ isPayer,setIsPayer ] = useState(true);
  const location = useLocation();
  const { privileges } = useContext(UserContext);

  const [selectedRows, setSelectedRows] = useState([]);
  const [contextMenu, setContextMenu] = useState(null);
  const [payModal,setPayModal ] = useState(false);
  const[validerPaiements,setValiderPaiements ] = useState(false);
  const[_id,setId ] = useState();
  const voirReceipt = (id) => {
    setModalOpen(true);
    setIsPayer(false);
    setId(id);
  }
  const [seachData,setSearchData ] = useState({
    startDate: "",
    endDate: ""
  });
  const columns = [
    {
      field: "ordre",
      headerName: "N°",
      minWidth: 80,
    },
    {
      field: "categorie",
      headerName: "Categorie",
      minWidth: 180
    },
    {
      field: "chassis",
      headerName: "chassis",
      minWidth: 180
    },
    {
      field: "reference",
      headerName: "Référence",
      minWidth: 210
    },
    {
      field: "agence",
      headerName: "Agence",
      minWidth: 150
    },
    {
      field: "typeClient",
      headerName: "Type Client",
      minWidth: 210
    },
    {
      field: "fullName",
      headerName: "Nom Complet",
      minWidth: 240
    },
    {
      field: "telephone",
      headerName: "Téléphone du Client",
      minWidth: 120
    },
   
    {
      field: "mode_paiement",
      headerName: "Mode Paiement",
      minWidth: 150
    },
   
    {
     field: "montantht",
     headerName: "Montant HT",
     minWidth: 150
    },
    {
      field: "montanttx",
      headerName: "Montant(18%)",
      minWidth: 150
     },
     {
      field: "montantttc",
      headerName: "Montant TTC",
      minWidth: 150
     },
     {
      field: "pvnumber",
      headerName: "N° PV",
      minWidth: 150
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 150,
     
      renderCell: (params) => {
        return (
         <div className='status'>
           <div className={`${params.row.status === `validé`?"valider":params.row.status === `annulé`?"annuler":"default-status"}`}>{ params.row.status }</div>
        </div>)
      }
    },
    {
      field: "date",
      headerName: "Date",
      minWidth: 150,
    
    },
    {
      field: "options",
      headerName: "Options",
      sortable: false,
      flex: 1,
      hide:false,
      filterable: false ,
      sortable:false,
      minWidth: 210,
      renderCell: (params) => {
        const id = params.id;
        return (
          <div className="options">
             <button onClick={() => navigate(`/ct/paiement/facture/${id}`)}>Voir facture</button>
             {(params.row.mode_paiement.toLowerCase() === "virement crédit" && validerPaiements) &&
               <button className='activate' onClick={() => soldPay(id)}>Payer</button>}
             { params.row.mode_paiement.toLowerCase() === "virement soldé" &&
               <button className='activate' onClick={() => voirReceipt(id)}>Voir le réçu</button>}  
          </div>
        );
      },
   }
  ];
  const IsValidateReceiptPrivilege = () => {
     return privileges.filter((p) => p.privilege === "Valider Virement Vadis").length > 0 ;
  }
  const soldPay = (id) => {
     setModalOpen(true);
     setIsPayer(true);
     setId(id)
  }
  const submitSearch = (e) => {
      e.preventDefault() 
      setPageState((prev) => ({...prev, page: 0}));
      getPaiements()
  }   
  const handleInput = (e)=>{
    setSearchData({...seachData,[e.target.name]:e.target.value });
  }
  const handleContextMenu = useCallback((event) => {
    event.preventDefault();
    const rowElement = event.currentTarget.closest('.MuiDataGrid-row');
 
    if (!rowElement) return;
  
    const rowId = rowElement.dataset.id;
    const rowData = pageState.data.find(row => row.id === Number(rowId));
   
    // Only show context menu for 'virement' or 'crédit' payment modes

    if (rowData && ['virement crédit'].includes(rowData.mode_paiement.toLowerCase())) {
      setContextMenu({
        mouseX: event.clientX - 2,
        mouseY: event.clientY - 4,
        rowId,
        rowData
      });
    }
  }, [pageState.data]);;
  const handleCloseContextMenu = () => {
    setContextMenu(null);
  };
  const getPaiements = async () => {
    var formdata = new FormData();
    setErreurs([]);setIsLoading(true);
    try{ 
    const page =  pageState.page + 1; 
    var url = `/paiement/ct/liste?pageSize=${pageState.pageSize}&currentPage=${page}`;
    if( location.state?.mode_paiement){
       url = url + '&mode_paiement=' + location.state?.mode_paiement
    }
   
    if( seachData?.startDate || seachData?.endDate ){
      url = url + '&filterData='+JSON.stringify(filterData)+'&filterDate='+ JSON.stringify(seachData) ;
    }
    else if( filterData.items.length > 0){
        url = url + '&filterData='+JSON.stringify(filterData);
    }
    const { status,data,montantttc,montantimpayer,errors } = await api.apiData("get",url,formdata);
    //console.log(montantttc,montantimpayer)
    setPageState((prev) => ({...prev,data:[]}));
 
    let getData = [];
    if( status === 200 ){
       if( data?.data?.length > 0 ){
            let loadedData =  data?.data; 
            getData = loadedData.map((item,index) => {  
            const montantht =  !isNaN(item.price) ? formatStringNumber((item.price / (1 + 18/100)).toFixed(2)): 0;
            const montant_tx = !isNaN(item.price) ? formatStringNumber((parseFloat(item.price) - (item.price / (1 + 18/100))).toFixed(2)) : 0
             return {
                id:item.paiement_id,
                ordre: data.from + index,
                categorie: item.name,
                chassis: item.chassis,
                reference:item.reference,
                typeClient: item.typeClient.charAt(0).toUpperCase() + item.typeClient.slice(1),
                fullName: (item.typeClient === "société" || item.typeClient === "gouvernement") ? item.nom : item.nomComplet,
                telephone: item.telephone,
                pvnumber:item.pvnumber || "Non fournie",
                mode_paiement: item.mode_paiement.charAt(0).toUpperCase() + item.mode_paiement.slice(1),
                montantttc: formatStringNumber(item.price),
                montantht: montantht,
                montanttx: montant_tx,
                status: item.status,
                agence: item.nom_agence,
                date:  moment(item.pupdated_at).format("Do MMM YYYY")
             }
          });
        
      }
      setPageState((prev) => ({...prev,data: getData,total:data.total}));
      setTotalNonPayer(montantimpayer);setTotalPayer(montantttc)
      
    }  
  }
  catch(e){
     console.log("Erreur:",e)
  } 
  finally{
    setIsLoading(false);
  } 
  }
const validSelectedRows = useMemo(() => {
  return selectedRows.filter(id => {
    const row = pageState?.data?.find((r) => r.id === id);
    return row && ['virement crédit'].includes(row.mode_paiement.toLowerCase());
  });
}, [selectedRows, pageState.data]);

  useEffect(() => {
   getPaiements();  
  },[pageState.page,pageState.pageSize,filterData,modalOpen,payModal]);

  useEffect(() => {
    setValiderPaiements(privileges.some(item => item.privilege === "Valider Virement Vadis"))
  },[])

  const apiRef = useGridApiRef();
  const getSelectedRowsData = () => {
    // Filter the data array to only include rows whose IDs are in selectedRows
    return pageState.data.filter(row => selectedRows.includes(row.id));
  };

  return (
    <div className='payment-list page'>
       <PayVirement 
         isOpen={modalOpen}
         setIsOpen={setModalOpen}
         setIsPayer={setIsPayer}
         isPayer={isPayer}
         id={_id} 
       /> 
       <Paymentgrp 
        isOpen={payModal}
        setIsOpen={setPayModal}
        IDS={validSelectedRows}
       />
       <DocumentTitle title="Liste des paiements" />
        <div className='header'>
              <h3>Liste de paiements</h3>
                <p>
                Paiements |  
                 <span>
                    <strong> Montant Payé : </strong>
                    {toWords.convert(totalPayer) + " Francs Guinéens"} (
                    <strong>{formatStringNumber(totalPayer)+ " fg"}</strong>)
                 </span>
                  / 
                  <span>
                    <strong> Montant Non Payé : </strong>
                    {toWords.convert(totalNonPayer) + " Francs Guinéens"} (
                    <strong>{formatStringNumber(totalNonPayer)+ " fg"}</strong>)
                 </span>
                </p>
        </div> 
        <div className="filters">
            <form onSubmit={submitSearch}>
                <h4>Filtres</h4>
                <div className="input-group">
                    <label>
                        Date début
                        <input type="date" name="startDate" 
                        id="startDate" 
                        placeholder="Date de début"
                        onChange={handleInput}
                        />
                    </label>
                    <label>
                        Date fin
                        <input type="date" name="endDate"
                        id="endDate" 
                        placeholder="Date de fin"
                        onChange={handleInput}
                        />
                    </label>
               </div>
               <Erreurs validation = {erreurs} />
               <button type="submit">Rechercher</button>
            </form>
       </div>
       <div className="array">
          <Box sx={{ height:'55.5vh',width: "100%" }}>
            <DataGridPremium
              sx={{ borderRadius: 0 }}
              density="compact"
              // components={{ Toolbar: ToolbarVadis }}
              columns={columns}
              autoPageSize
              pagination
              disableSelectionOnClick={false}
              rowCount={pageState?.total}
              rows={pageState.data || []}
              page={pageState.page - 1 }
            
              onPaginationModelChange={setPageState}
              localeText={ frFR.components.MuiDataGrid.defaultProps.localeText }
              paginationMode="server"
              slots={{
                toolbar: ToolbarVadis, // Your custom component
               
              }}
              slotProps={{
                toolbar: { // Props for your custom component
                  seachData,
                  filterData,
                  isLoading,
                  setIsLoading 
                },
                row: {
                  onContextMenu: handleContextMenu,
                  style:(params) => ({
                    cursor: ['virement crédit'].includes(params.row.mode_paiement.toLowerCase()) 
                    ? 'context-menu' 
                    : 'default'
                  })
                }
              }}
              filterMode="server"
              onFilterModelChange={(newFilterModel) => {
                 setFilterData(newFilterModel);
              }}
              onPageSizeChange={(newpageSize, details ) => {
                // Maybe save into state
                setPageState((prev) => ({...prev,pageSize:newpageSize}))
              }}
              onPageChange={(newPage) => {
                setPageState(prev => ({ ...prev, page: newPage + 1 }))
              }}
              apiRef={apiRef}
            
              checkboxSelection={validerPaiements}
              isRowSelectable={(params) => params.row.mode_paiement.toLowerCase() === 'virement crédit'}
              onRowSelectionModelChange={(newSelection) => {
               // console.log('Selection changed:', newSelection);

                setSelectedRows(newSelection);
              }}
              rowSelectionModel={selectedRows}
            
              getRowId={(row) => row.id} 
               
              />
            {validerPaiements &&
             (<Menu
           open={contextMenu !== null}
           onClose={handleCloseContextMenu}
           anchorReference="anchorPosition"
           anchorPosition={
             contextMenu !== null
              ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
              : undefined
           }
          >
            <MenuItem onClick={() => {
              //console.log('Edit row:', selectedRows);
              if( Array.isArray(validSelectedRows) && validSelectedRows.length > 0 ){
                 setPayModal(true);
              }
              //console.log('Valid selected rows:', validSelectedRows);
              handleCloseContextMenu();
            }}>
              Procéder au paiement
            </MenuItem>
            {/* <MenuItem onClick={() => {
              console.log('Delete row:', contextMenu?.rowId);
              handleCloseContextMenu();
            }}>
              Delete
            </MenuItem> */}
            </Menu>)}
              
          </Box>
        </div>  
    </div>
  )
}

export default PaymentListVadis